import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=7bf4d151"
import script from "./Webcam.vue?vue&type=script&lang=ts"
export * from "./Webcam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports